// src/components/Filters/HealthGoalsFilter.js
import React from 'react';
import { healthGoalsList } from '../../data/filterOptions';
import './FilterStyles.css';

const HealthGoalsFilter = ({ selectedGoals, onChange }) => {
  const handleChange = (goal) => {
    const newSelectedGoals = selectedGoals.includes(goal)
      ? selectedGoals.filter(g => g !== goal)
      : [...selectedGoals, goal];
    onChange(newSelectedGoals);
  };

  return (
    <div className="filter-section">
      <h3>Health Goals</h3>
      <div className="filter-options-grid checkbox-grid-health">
        {healthGoalsList.map(goal => (
          <label key={goal} className="filter-option-label">
            <input
              type="checkbox"
              checked={selectedGoals.includes(goal)}
              onChange={() => handleChange(goal)}
            />
            {goal}
          </label>
        ))}
      </div>
    </div>
  );
};

export default HealthGoalsFilter;
